import { DesignFilesByType } from "../../../Interfaces/FundraiserRole";

const designs: DesignFilesByType = {
  bottles: {
    general: {
      __no_subcategory__: [
        {
          id: 4,
          file_name: "America 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/america_2_laser_engraved_design_20250711_162043.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 5,
          file_name: "Butterfly 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/butterfly_1_laser_engraved_design_20250711_162327.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 3,
          file_name: "America 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/america_1_laser_engraved_design_20250711_162633.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 6,
          file_name: "Butterfly 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/butterfly_2_laser_engraved_design_20250711_163129.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 7,
          file_name: "Butterfly 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/butterfly_3_laser_engraved_design_20250711_163203.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 8,
          file_name: "Cat 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cat_1_laser_engraved_design_20250711_163356.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 9,
          file_name: "Cat 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cat_2_laser_engraved_design_20250711_163451.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 10,
          file_name: "Dog 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/dog_1_laser_engraved_design_20250711_163538.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 11,
          file_name: "Dog 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/dog_2_laser_engraved_design_20250711_163813.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 12,
          file_name: "Dog 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/dog_3_laser_engraved_design_20250711_163841.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 13,
          file_name: "Flower 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/flower_1_laser_engraved_design_20250711_163948.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 14,
          file_name: "Flower 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/flower_2_laser_engraved_design_20250711_164049.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 15,
          file_name: "Flower 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/flower_3_laser_engraved_design_20250711_164113.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 16,
          file_name: "Inspo 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/inspo_2_laser_engraved_design_20250711_164137.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 17,
          file_name: "Inspo 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/inspo_3_laser_engraved_design_20250711_164158.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 18,
          file_name: "Inspo 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/inspo_4_laser_engraved_design_20250711_164223.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
      ],
    },
    music: {
      __no_subcategory__: [
        {
          id: 19,
          file_name: "Band 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/band_1_laser_engraved_design_20250711_164334.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 20,
          file_name: "Band 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/band_2_laser_engraved_design_20250711_165134.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 21,
          file_name: "Band 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/band_3_laser_engraved_design_20250711_165235.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 22,
          file_name: "Band 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/band_4_laser_engraved_design_20250711_165441.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 23,
          file_name: "Choir 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/choir_1_laser_engraved_design_20250711_165523.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 24,
          file_name: "Choir 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/choir_3_laser_engraved_design_20250711_165544.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 25,
          file_name: "Music 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/music_1_laser_engraved_design_20250711_165559.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 26,
          file_name: "Music 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/music_2_laser_engraved_design_20250711_165620.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
      ],
    },
    occupational: {
      __no_subcategory__: [
        {
          id: 27,
          file_name: "Doctor 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/doctor_1_laser_engraved_design_20250711_170212.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 28,
          file_name: "Doctor 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/doctor_2_laser_engraved_design_20250711_170240.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 29,
          file_name: "Doctor 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/doctor_3_laser_engraved_design_20250711_170333.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 30,
          file_name: "Firefighter 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/firefighter_2_laser_engraved_design_20250711_170359.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 31,
          file_name: "Firefighter 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/firefighter_3_laser_engraved_design_20250711_170435.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 32,
          file_name: "Nurse 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/nurse_1_laser_engraved_design_20250711_170505.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 33,
          file_name: "Nurse 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/nurse_2_laser_engraved_design_20250711_170548.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 34,
          file_name: "Nurse 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/nurse_3_laser_engraved_design_20250711_170738.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 35,
          file_name: "Teacher 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/teacher_1_laser_engraved_design_20250711_170754.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 36,
          file_name: "Teacher 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/teacher_2_laser_engraved_design_20250711_170812.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 37,
          file_name: "Teacher 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/teacher_3_laser_engraved_design_20250711_170848.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
      ],
    },
    sports: {
      basketball: [
        {
          id: 38,
          file_name: "Basketball 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/basketball_1_laser_engraved_design_20250711_173337.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "basketball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 39,
          file_name: "Basketball 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/basketball_2_laser_engraved_design_20250711_173411.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "basketball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 40,
          file_name: "Basketball 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/basketball_3_laser_engraved_design_20250711_173446.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "basketball",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      baseball: [
        {
          id: 41,
          file_name: "Baseball 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/baseball_1_laser_engraved_design_20250711_173553.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 42,
          file_name: "Baseball 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/baseball_2_laser_engraved_design_20250711_173708.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 43,
          file_name: "Baseball 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/baseball_3_laser_engraved_design_20250711_173820.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 44,
          file_name: "Baseball 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/baseball_4_laser_engraved_design_20250711_173859.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 45,
          file_name: "Baseball 5",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/baseball_5_laser_engraved_design_20250711_173923.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 46,
          file_name: "Baseball 6",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/baseball_6_laser_engraved_design_20250711_174008.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 47,
          file_name: "Baseball 7",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/baseball_7_laser_engraved_design_20250711_174148.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 48,
          file_name: "Baseball 8",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/baseball_8_laser_engraved_design_20250711_174207.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 49,
          file_name: "Baseball 9",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/baseball_9_laser_engraved_design_20250711_174226.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 50,
          file_name: "Baseball 10",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/baseball_10_laser_engraved_design_20250711_174241.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      cheer: [
        {
          id: 51,
          file_name: "Cheer 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_1_laser_engraved_design_20250711_212013.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 52,
          file_name: "Cheer 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_2_laser_engraved_design_20250711_212047.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 53,
          file_name: "Cheer 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_3_laser_engraved_design_20250711_212213.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 54,
          file_name: "Cheer 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_4_laser_engraved_design_20250711_212230.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 55,
          file_name: "Cheer 5",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_5_laser_engraved_design_20250711_212245.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 56,
          file_name: "Cheer 6",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_6_laser_engraved_design_20250711_212348.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 57,
          file_name: "Cheer 7",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_7_laser_engraved_design_20250711_212405.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 58,
          file_name: "Cheer 8",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_8_laser_engraved_design_20250711_212420.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 59,
          file_name: "Cheer 9",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_9_laser_engraved_design_20250711_212453.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 60,
          file_name: "Cheer 10",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_10_laser_engraved_design_20250711_212534.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 61,
          file_name: "Cheer 11",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_11_laser_engraved_design_20250711_212551.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 62,
          file_name: "Cheer 12",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/cheer_12_laser_engraved_design_20250711_212605.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      dance: [
        {
          id: 63,
          file_name: "Dance 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/dance_1_laser_engraved_design_20250711_212656.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "dance",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 64,
          file_name: "Dance 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/dance_2_laser_engraved_design_20250711_212731.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "dance",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      flag_football: [
        {
          id: 65,
          file_name: "Flag Football 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/flag_football_1_laser_engraved_design_20250711_212921.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "flag_football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 66,
          file_name: "Flag Football 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/flag_football_2_laser_engraved_design_20250711_212941.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "flag_football",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      football: [
        {
          id: 67,
          file_name: "Football 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/football_1_laser_engraved_design_20250711_213042.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 68,
          file_name: "Football 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/football_2_laser_engraved_design_20250711_213110.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 69,
          file_name: "Football 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/football_3_laser_engraved_design_20250711_213140.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 70,
          file_name: "Football 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/football_4_laser_engraved_design_20250711_213224.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 71,
          file_name: "Football 5",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/football_5_laser_engraved_design_20250711_213350.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 73,
          file_name: "Football 7",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/football_7_laser_engraved_design_20250711_213444.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 74,
          file_name: "Football 8",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/football_8_laser_engraved_design_20250711_213515.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 75,
          file_name: "Football 9",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/football_9_laser_engraved_design_20250711_213533.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 72,
          file_name: "Football 6",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/football_6_laser_engraved_design_20250809_044230.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      lacrosse: [
        {
          id: 76,
          file_name: "Lacrosse 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/lacrosse_1_laser_engraved_design_20250711_213713.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "lacrosse",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 77,
          file_name: "Lacrosse 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/lacrosse_2_laser_engraved_design_20250711_213733.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "lacrosse",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 78,
          file_name: "Lacrosse 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/lacrosse_3_laser_engraved_design_20250711_213800.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "lacrosse",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      soccer: [
        {
          id: 79,
          file_name: "Soccer 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/soccer_1_laser_engraved_design_20250711_213852.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "soccer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 80,
          file_name: "Soccer 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/soccer_2_laser_engraved_design_20250711_213914.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "soccer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 81,
          file_name: "Soccer 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/soccer_3_laser_engraved_design_20250711_213935.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "soccer",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      softball: [
        {
          id: 82,
          file_name: "Softball 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/softball_1_laser_engraved_design_20250711_214227.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 83,
          file_name: "Softball 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/softball_2_laser_engraved_design_20250711_214249.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 84,
          file_name: "Softball 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/softball_3_laser_engraved_design_20250711_214308.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 85,
          file_name: "Softball 5",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/softball_5_laser_engraved_design_20250711_214330.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 86,
          file_name: "Softball 6",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/softball_6_laser_engraved_design_20250711_214349.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 87,
          file_name: "Softball 7",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/softball_7_laser_engraved_design_20250711_214435.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 88,
          file_name: "Softball 8",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/softball_8_laser_engraved_design_20250711_215555.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 89,
          file_name: "Softball 9",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/softball_9_laser_engraved_design_20250711_215619.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 90,
          file_name: "Softball 10",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/softball_10_laser_engraved_design_20250711_215712.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      tennis: [
        {
          id: 91,
          file_name: "Tennis 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/tennis_1_laser_engraved_design_20250711_215806.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "tennis",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 92,
          file_name: "Tennis 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/tennis_2_laser_engraved_design_20250711_215824.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "tennis",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      track_field: [
        {
          id: 93,
          file_name: "Track & Field 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/track_%26_field_1_laser_engraved_design_20250711_215922.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "track_field",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 94,
          file_name: "Track & Field 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/laser_engraved_design/track_%26_field_2_laser_engraved_design_20250711_220001.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "track_field",
              },
            ],
          },
          fundraiser: null,
        },
      ],
    },
  },
  clothing: {
    general: {
      __no_subcategory__: [
        {
          id: 95,
          file_name: "America 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/america_1_ink_design_20250711_220503.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 96,
          file_name: "America 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/america_2_ink_design_20250711_220523.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 97,
          file_name: "Butterfly 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/butterfly_1_ink_design_20250711_220552.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 98,
          file_name: "Butterfly 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/butterfly_2_ink_design_20250711_220607.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 99,
          file_name: "Butterfly 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/butterfly_3_ink_design_20250711_220705.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 100,
          file_name: "Cat 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cat_2_ink_design_20250711_220729.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 101,
          file_name: "Cat 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cat_3_ink_design_20250711_220808.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 102,
          file_name: "Dog 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/dog_1_ink_design_20250711_220839.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 103,
          file_name: "Dog 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/dog_2_ink_design_20250711_220918.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 104,
          file_name: "Dog 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/dog_3_ink_design_20250711_220957.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 105,
          file_name: "Flower 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/flower_1_ink_design_20250711_221026.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 106,
          file_name: "Flower 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/flower_2_ink_design_20250711_221047.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 107,
          file_name: "Flower 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/flower_3_ink_design_20250711_221140.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 108,
          file_name: "Inspo 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/inspo_1_ink_design_20250711_221215.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 109,
          file_name: "Inspo 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/inspo_2_ink_design_20250711_221230.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 110,
          file_name: "Inspo 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/inspo_3_ink_design_20250711_221249.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 111,
          file_name: "Inspiration 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/inspiration_4_ink_design_20250711_221328.png",
          extra_info: {
            categories: [
              {
                name: "general",
              },
            ],
          },
          fundraiser: null,
        },
      ],
    },
    music: {
      __no_subcategory__: [
        {
          id: 112,
          file_name: "Band 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/band_1_ink_design_20250711_221420.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 113,
          file_name: "Band 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/band_2_ink_design_20250711_221441.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 114,
          file_name: "Band 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/band_3_ink_design_20250711_221502.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 115,
          file_name: "Band 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/band_4_ink_design_20250711_221517.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 116,
          file_name: "Choir 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/choir_1_ink_design_20250711_221532.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 117,
          file_name: "Music 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/music_1_ink_design_20250711_221559.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 118,
          file_name: "Music 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/music_2_ink_design_20250711_221616.png",
          extra_info: {
            categories: [
              {
                name: "music",
              },
            ],
          },
          fundraiser: null,
        },
      ],
    },
    occupational: {
      __no_subcategory__: [
        {
          id: 119,
          file_name: "Doctor 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/doctor_1_ink_design_20250711_221732.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 120,
          file_name: "Doctor 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/doctor_2_ink_design_20250711_221750.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 121,
          file_name: "Doctor 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/doctor_3_ink_design_20250711_221802.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 122,
          file_name: "Firefighter 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/firefighter_2_ink_design_20250711_221822.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 123,
          file_name: "Firefighter 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/firefighter_3_ink_design_20250711_221838.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 124,
          file_name: "Nurse 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/nurse_1_ink_design_20250711_221903.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 125,
          file_name: "Nurse 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/nurse_2_ink_design_20250711_221923.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 126,
          file_name: "Nurse 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/nurse_3_ink_design_20250711_221935.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 127,
          file_name: "Teacher 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/teacher_1_ink_design_20250711_221951.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 128,
          file_name: "Teacher 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/teacher_2_ink_design_20250711_222001.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 129,
          file_name: "Teacher 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/teacher_3_ink_design_20250711_222019.png",
          extra_info: {
            categories: [
              {
                name: "occupational",
              },
            ],
          },
          fundraiser: null,
        },
      ],
    },
    sports: {
      baseball: [
        {
          id: 130,
          file_name: "Baseball 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/baseball_1_ink_design_20250712_171005.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 131,
          file_name: "Baseball 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/baseball_2_ink_design_20250712_172159.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 132,
          file_name: "Baseball 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/baseball_3_ink_design_20250712_173052.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 133,
          file_name: "Baseball 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/baseball_4_ink_design_20250712_173228.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 134,
          file_name: "Baseball 5",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/baseball_5_ink_design_20250712_173248.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 135,
          file_name: "Baseball 6",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/baseball_6_ink_design_20250712_173314.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 136,
          file_name: "Baseball 7",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/baseball_7_ink_design_20250712_173348.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 137,
          file_name: "Baseball 8",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/baseball_8_ink_design_20250712_173405.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 138,
          file_name: "Baseball 9",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/baseball_9_ink_design_20250712_173508.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 139,
          file_name: "Baseball 10",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/baseball_10_ink_design_20250712_173620.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "baseball",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      basketball: [
        {
          id: 140,
          file_name: "Basketball 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/basketball_1_ink_design_20250712_173855.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "basketball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 141,
          file_name: "Basketball 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/basketball_2_ink_design_20250712_173912.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "basketball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 142,
          file_name: "Basketball 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/basketball_3_ink_design_20250712_173924.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "basketball",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      cheer: [
        {
          id: 143,
          file_name: "Cheer 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_1_ink_design_20250712_175604.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 144,
          file_name: "Cheer 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_2_ink_design_20250712_175625.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 145,
          file_name: "Cheer 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_3_ink_design_20250712_175700.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 146,
          file_name: "Cheer 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_4_ink_design_20250712_175959.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 147,
          file_name: "Cheer 5",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_5_ink_design_20250712_180116.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 148,
          file_name: "Cheer 6",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_6_ink_design_20250712_180209.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 149,
          file_name: "Cheer 7",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_7_ink_design_20250712_180239.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 150,
          file_name: "Cheer 8",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_8_ink_design_20250712_180254.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 151,
          file_name: "Cheer 9",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_9_ink_design_20250712_180306.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 152,
          file_name: "Cheer 10",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_10_ink_design_20250712_180318.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 153,
          file_name: "Cheer 11",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_11_ink_design_20250712_180328.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 154,
          file_name: "Cheer 12",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/cheer_12_ink_design_20250712_180339.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "cheer",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      dance: [
        {
          id: 155,
          file_name: "Dance 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/dance_1_ink_design_20250712_180408.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "dance",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 156,
          file_name: "Dance 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/dance_2_ink_design_20250712_180419.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "dance",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      flag_football: [
        {
          id: 157,
          file_name: "Flag Football 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/flag_football_1_ink_design_20250712_180507.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "flag_football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 158,
          file_name: "Flag Football 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/flag_football_2_ink_design_20250712_180541.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "flag_football",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      football: [
        {
          id: 159,
          file_name: "Football 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/football_1_ink_design_20250712_180617.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 160,
          file_name: "Football 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/football_2_ink_design_20250712_180952.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 161,
          file_name: "Football 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/football_3_ink_design_20250712_181012.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 162,
          file_name: "Football 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/football_4_ink_design_20250712_181117.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 163,
          file_name: "Football 5",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/football_5_ink_design_20250712_181443.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 164,
          file_name: "Football 6",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/football_6_ink_design_20250712_181505.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 165,
          file_name: "Football 7",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/football_7_ink_design_20250712_181523.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 166,
          file_name: "Football 8",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/football_8_ink_design_20250712_181551.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 167,
          file_name: "Football 9",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/football_9_ink_design_20250712_181609.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 168,
          file_name: "Football 9",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/football_9_ink_design_20250712_181632.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "football",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      lacrosse: [
        {
          id: 169,
          file_name: "Lacrosse 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/lacrosse_1_ink_design_20250712_181807.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "lacrosse",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 170,
          file_name: "Lacrosse 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/lacrosse_2_ink_design_20250712_181852.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "lacrosse",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 171,
          file_name: "Lacrosse 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/lacrosse_3_ink_design_20250712_181908.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "lacrosse",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      soccer: [
        {
          id: 172,
          file_name: "Soccer 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/soccer_1_ink_design_20250712_182038.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "soccer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 173,
          file_name: "Soccer 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/soccer_2_ink_design_20250712_182131.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "soccer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 174,
          file_name: "Soccer 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/soccer_3_ink_design_20250712_182215.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "soccer",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 175,
          file_name: "Soccer 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/soccer_4_ink_design_20250712_182233.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "soccer",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      softball: [
        {
          id: 176,
          file_name: "Softball 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/softball_1_ink_design_20250712_182333.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 177,
          file_name: "Softball 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/softball_2_ink_design_20250712_182531.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 178,
          file_name: "Softball 3",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/softball_3_ink_design_20250712_182545.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 179,
          file_name: "Softball 4",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/softball_4_ink_design_20250712_182614.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 180,
          file_name: "Softball 5",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/softball_5_ink_design_20250712_182624.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 181,
          file_name: "Softball 6",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/softball_6_ink_design_20250712_182635.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 182,
          file_name: "Softball 7",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/softball_7_ink_design_20250712_182646.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 183,
          file_name: "Softball 8",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/softball_8_ink_design_20250712_182658.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 184,
          file_name: "Softball 9",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/softball_9_ink_design_20250712_182758.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 185,
          file_name: "Softball 10",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/softball_10_ink_design_20250712_182818.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "softball",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      tennis: [
        {
          id: 186,
          file_name: "Tennis 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/tennis_1_ink_design_20250712_182929.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "tennis",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 187,
          file_name: "Tennis 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/tennis_2_ink_design_20250712_182944.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "tennis",
              },
            ],
          },
          fundraiser: null,
        },
      ],
      track_field: [
        {
          id: 188,
          file_name: "Track & Field 1",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/track_%26_field_1_ink_design_20250712_183018.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "track_field",
              },
            ],
          },
          fundraiser: null,
        },
        {
          id: 189,
          file_name: "Track & Field 2",
          file_location:
            "https://prod-mamfam-data.s3.amazonaws.com/ink_design/track_%26_field_2_ink_design_20250712_183032.png",
          extra_info: {
            categories: [
              {
                name: "sports",
                sub_cat: "track_field",
              },
            ],
          },
          fundraiser: null,
        },
      ],
    },
  },
  bears: {},
  spangle: {},
};

export default designs;
